import { EventEmitter } from 'events';
export class TypedEventEmitter {
    constructor() {
        this.emitter = new EventEmitter();
    }
    emit(eventName, eventArg) {
        this.emitter.emit(eventName, eventArg);
    }
    on(eventName, handler) {
        this.emitter.on(eventName, handler);
    }
    once(eventName, handler) {
        this.emitter.once(eventName, handler);
    }
    off(eventName, handler) {
        this.emitter.off(eventName, handler);
    }
}
//# sourceMappingURL=TypedEventEmitter.js.map